// extracted by mini-css-extract-plugin
export default {"root":"TopNav_root__bfD3k","root__arrow":"TopNav_root__arrow__OXx+K","root__title":"TopNav_root__title__V2YC1"};